// JS for inclusion page
$(document).ready(function() {
    initSlider();

    //we need to maintain a set height when a resize event occurs.
    //Some events will through a resize trigger: $(window).trigger('resize');
    $(window).on('resize', function(e) {
        if ($(this).width() < 768) {
            $('.mobile-slider').addClass('testimonial-slick');
            initSlider();
        } else {
            $('.testimonial-slick').slick('unslick');
            $('.mobile-slider').removeClass('testimonial-slick');
        }
    });

    //since multiple events can trigger a slider adjustment, we will control that adjustment here
    function resizeSlider() {
        $slickSlider = $('.testimonial-slick');
        $slickSlider.find('.slick-slide').height('auto');

        var slickTrack = $slickSlider.find('.slick-track');
        var slickTrackHeight = $(slickTrack).height();

        $slickSlider.find('.slick-slide').css('height', slickTrackHeight + 'px');
    }

    function initSlider() {
        $slickSlider = $('.testimonial-slick');
        var slickTrack = $slickSlider.find('.slick-track');

        $('.testimonial-slick')
            .not('.slick-initialized')
            .slick({
                slidesToShow: 1,
                autoplay: false,
                autoplaySpeed: 6000,
                arrows: false,
                dots: false
            })
            .on('setPosition', function() {
                resizeSlider();
            });
    }
});
